import React, { useState, useEffect, useRef } from 'react';
import '../Maintenance-styles/modal.css'
import SelectorGroupModal from './SelectorGroupModal'; // Modal para seleccionar grupos
import SelectorHostModal from './SelectorHostModal'; // Modal para seleccionar hosts
import SelectorUserModal from './SelectorUserModal'; // Modal para seleccionar usuarios
import Loader from './Loader';



const EditEventModal = ({event, onClose, onUpdate, groups, hosts, users}) => {
    //stados para contener cada dato del modal de edicion
    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const [start_time, setStart_time] = useState('')
    const [end_time, setEnd_time] = useState('')
    const [eventType, setEventType] = useState('')
    const [selectedGroups, setSelectedGroups] = useState([])
    const [selectedHosts, setSelectedHosts] = useState([])
    const [selectedUsers, setSelectedUsers] = useState([])
    const [isLoading, setIsLoading] = useState(false) //estado de visibilidad de loader

        // Estados para controlar la apertura de modales selectores(catalogos host, grupos, users)
    const [isGroupModalOpen, setIsGroupModalOpen] = useState(false);
    const [isHostModalOpen, setIsHostModalOpen] = useState(false);
    const [isUserModalOpen, setIsUserModalOpen] = useState(false);

    const hasInitialized = useRef(false); // Para evitar renderizados infinitos

    useEffect(() => {
        if (!hasInitialized.current && event) {
            hasInitialized.current = true;
            // console.log("event recibido para edit: ", event)
            // console.log("groups recibido para edit: ", groups)
            // console.log("hosts recibido para edit: ", hosts)
            // console.log("users recibido para edit: ", users)

            setName(event.name || '')
            setDescription(event.description || '')
            setStart_time(event.start_time || '')
            setEnd_time(event.end_time || '')
            setEventType(event.event_type || '')

            const eventGroups= groups.filter((g) => event.groupids?.includes(g.groupid));
            setSelectedGroups(eventGroups);

            const eventHosts= hosts.filter((h) => event.hostids?.includes(h.hostid));
            setSelectedHosts(eventHosts);

            const eventUsers= users.filter((u) => event.userids?.includes(u.user_id));
            setSelectedUsers(eventUsers);
        }     
    }, [event, groups, hosts, users]);


    const handleRemoveItem = (setList, id) => {
        setList((prev) =>
          prev.filter((item) => item.groupid !== id && item.hostid !== id && item.user_id !== id)
        );
      };

      const handleSelectGroup = (group) => {
        if (!selectedGroups.some((g) => g.groupid === group.groupid)) {
          setSelectedGroups([...selectedGroups, group]);
        }
      };
    
      const handleSelectHost = (host) => {
        if (!selectedHosts.some((h) => h.hostid === host.hostid)) {
          setSelectedHosts([...selectedHosts, host]);
        }
      };
    
      const handleSelectUser = (user) => {
        if (!selectedUsers.some((u) => u.user_id === user.user_id)) {
          setSelectedUsers([...selectedUsers, user]);
        }
      };
    


      const handleUpdate = () => {
        const updatedEvent = {
          id: event.id,
          name,
          description,
          start_time,
          end_time,
          event_type: eventType,
          groupids: selectedGroups.map((g) => g.groupid),
          hostids: selectedHosts.map((h) => h.hostid),
          userids: selectedUsers.map((u) => u.user_id),
          interested_type: "user",
          usergroupids: []
        };
        onUpdate(updatedEvent);
    };

    
 // Función para eliminar el evento
 const handleDelete = async () => {
    setIsLoading(true); // Muestra el loader al inicio de la carga  
    const confirmed = window.confirm('¿Estás seguro de que deseas cancelar este evento?');
    if (!confirmed) return;

    try {
      const response = await fetch(`http://localhost:8000/maintenance/delete_event/${event.id}`, {
        method: 'DELETE',
      });

      if (response.ok) {
        alert('Evento cancelado exitosamente');
        onClose(); // Cerrar el modal después de la eliminación
        window.location.reload(); // Recargar la página para actualizar el calendario
      } else {
        alert('Error al cancelar el evento');
      }
    } catch (error) {
      console.error('Error al eliminar el evento:', error);
      alert('Error al cancelar el evento');
    } finally{
        setIsLoading(false); // Muestra el loader al inicio de la carga  
    }
  };


    return(
        <>
            <div className="modal-overlay" onClick={onClose}></div>
            <div className='modal'>
            {/* aqui va loader */}
            {isLoading && <Loader />}

                {!isGroupModalOpen && !isHostModalOpen && !isUserModalOpen &&(
                    <>
                            <h2>Editar Evento</h2>

                            <label>Título del Evento</label>
                            <input value={name} onChange={(e) => setName(e.target.value)} type="text" />

                            <label>Descripción</label>
                            <textarea value={description} onChange={(e) => setDescription(e.target.value)} />

                            <label>Fecha de Inicio</label>
                            <input value={start_time} onChange={(e) => setStart_time(e.target.value)} type="datetime-local" />

                            <label>Fecha de Fin</label>
                            <input value={end_time} onChange={(e) => setEnd_time(e.target.value)} type="datetime-local" />

                            <label>Tipo de Mantenimiento</label>
                            <select value={eventType} onChange={(e) => setEventType(e.target.value)}>
                            <option value="">Seleccionar tipo</option>
                            <option value="group">Grupal</option>
                            <option value="host">Dispositivo</option>
                            </select>
                    </>
                )}

     

                {eventType === 'group' && (
                <>

                    <button className="add-group-button"  onClick={() => setIsGroupModalOpen(true)}>Agregar grupos</button>
                    
                    <div className='tag-container'>
                        {selectedGroups.map((group) => (
                            <span key={group.groupid} className='tag'>      
                                {group.name}
                                <button className='remove-tag' onClick={() => handleRemoveItem(setSelectedGroups, group.groupid)}>
                                    &times;
                                </button>
                            </span>
                        ))}
                    </div>
                </>
                )}


                
                {eventType === 'host' && (
                <>
                    <button   className="add-host-button" onClick={() => setIsHostModalOpen(true)}>Agregar Dispositivos</button>
                    <div className="tag-container">
                    {selectedHosts.map((host) => (
                        <span key={host.hostid} className="tag">
                            {host.name}
                            <button className="remove-tag"  onClick={() => handleRemoveItem(setSelectedHosts, host.hostid)}>
                                &times;
                            </button>
                        </span>
                    ))}
                    </div>
                </>
                )}

                <button  className="add-user-button"  onClick={() => setIsUserModalOpen(true)}>Agregar Usuarios</button>
                <div className="tag-container">
                {selectedUsers.map((user) => (
                    <span key={user.user_id} className="tag">
                    {user.name}
                    <button className="remove-tag" onClick={() => handleRemoveItem(setSelectedUsers, user.user_id)}>
                        &times;
                    </button>
                    </span>
                ))}


                {isGroupModalOpen && (
                <SelectorGroupModal
                    groups={groups}
                    onClose={() => setIsGroupModalOpen(false)}
                    onSelectGroup={handleSelectGroup}
                />
                )}

                {isHostModalOpen && (
                <SelectorHostModal
                    hosts={hosts}
                    onClose={() => setIsHostModalOpen(false)}
                    onSelectHost={handleSelectHost}
                />
                )}

                {isUserModalOpen && (
                <SelectorUserModal
                    users={users}
                    onClose={() => setIsUserModalOpen(false)}
                    onSelectUser={handleSelectUser}
                />
                )}
                </div>


                <label>Alarma</label>
                    <select >
                    <option value="">Sin Alarma</option>
                    <option value="group">Una hora antes</option>
                    <option value="host">1 dia antes</option>
                    <option value="group">2 dias antes</option>
                    <option value="host">1 semana antes</option>
                </select>

                <div className="button-container">
                    <button onClick={handleDelete} className="cancel-button">Cancelar Evento</button>
                    <button className='create-button' onClick={handleUpdate}>Guardar</button>
                </div>

                        
            </div>
        </>
    )
}

export default EditEventModal;